import { render, staticRenderFns } from "./StateGovernmentDeclar.vue?vue&type=template&id=41a0293c&scoped=true&"
import script from "./StateGovernmentDeclar.vue?vue&type=script&lang=js&"
export * from "./StateGovernmentDeclar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0293c",
  null
  
)

export default component.exports